import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vue-awesome/icons'


import Icon from 'vue-awesome/components/Icon'

Vue.component('v-icon', Icon)

Vue.config.productionTip = false

Vue.prototype.$store = store
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
